<template>
  <div class="home">
    <div>
            <div>
                <section>
                    <div class="py-8 px-8">
                    <div class="d-flex flex-wrap align-items-center justify-content-between">
                        <div class="col-12 col-lg-auto mb-4 mb-lg-0">
                        <div class="d-flex align-items-center">
                            <h4 class="mb-0 me-2">{{$t('pos_transactions')}}</h4>
                        </div>
                        </div>
                        <div class="col-12 col-lg-auto d-flex align-items-center">
                            
                            <!-- Simple Search -->
                            <div class="input-group flex-grow-1" style="border-bottom: 1px solid #ddd;">
                                <input class="form-control border-0 search-input" autocomplete="off" type="text" v-model="search" :placeholder="$t('search')">
                            </div>
                        </div>
                    </div>
                    
                    <!-- Advanced Search Filters -->
                    <div v-if="showAdvancedSearch" class="mt-4 p-4 advanced-search-section">
                        <div class="row g-3">
                            <div class="col-md-3">
                                <label class="form-label">{{$t('reference')}}</label>
                                <input v-model="filters.reference" type="text" class="form-control filter-input">
                            </div>
                            <div class="col-md-3">
                                <label class="form-label">{{$t('cashier')}}</label>
                                <input v-model="filters.cashier" type="text" class="form-control filter-input">
                            </div>
                            <div class="col-md-3">
                                <label class="form-label">{{$t('cash_register')}}</label>
                                <input v-model="filters.cash_register" type="text" class="form-control filter-input">
                            </div>
                            <div class="col-md-3">
                                <label class="form-label">{{$t('total_amount')}}</label>
                                <input v-model="filters.total_amount" type="number" class="form-control filter-input" placeholder="Min amount">
                            </div>
                            <div class="col-md-3">
                                <label class="form-label">{{$t('payment_status')}}</label>
                                <select v-model="filters.payment_status" class="form-select filter-input">
                                    <option value="">{{$t('all')}}</option>
                                    <option value="paid">{{$t('paid')}}</option>
                                    <option value="pending">{{$t('pending')}}</option>
                                    <option value="canceled">{{$t('canceled')}}</option>
                                </select>
                            </div>
                            <div class="col-12 d-flex justify-content-end">
                                <button @click="clearFilters" class="btn btn-secondary me-2">
                                    <AppIcon name="bi-x-circle" class="bi bi-x-circle" />
                                    {{$t('clear_filters')}}
                                </button>
                                <button @click="applyFilters" class="btn btn-success">
                                    <AppIcon name="bi-search" class="bi bi-search" />
                                    {{$t('apply_filters')}}
                                </button>
                            </div>
                        </div>
                    </div>
                    </div>
                </section>
            </div>
      
            <section class="">
                <div class="px-8">

                    <div class="row align-items-end g-2 mb-4">
                        
                        <!-- Filter Dropdown (Shopify Style) -->
                        <div class="col-12 col-md-auto">
                            <div class="dropdown">
                                <button class="btn btn-outline-secondary dropdown-toggle btn-sm" type="button" id="posFilterDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                    <AppIcon name="bi-funnel" class="bi bi-funnel" /> {{$t('filter')}}
                                    <span v-if="activeFilters.length" class="badge bg-secondary ms-1">{{activeFilters.length}}</span>
                                </button>
                                <button v-if="activeFilters.length" class="btn btn-link btn-sm text-danger text-decoration-none ms-2" type="button" @click.stop="clearAllFilters">
                                    <AppIcon name="bi-x-circle" class="bi bi-x-circle me-1" />{{$t('clear_all')}}
                                </button>
                                <div class="dropdown-menu p-3" aria-labelledby="posFilterDropdown" style="min-width: 300px;" @click.stop>
                                    
                                    <!-- Active Filters -->
                                    <div v-if="activeFilters.length > 0" class="mb-3">
                                        <div v-for="(filter, index) in activeFilters" :key="index" class="mb-2">
                                            <label class="form-label small mb-1">{{$t(filter.key)}}</label>
                                            <div class="input-group input-group-sm">
                                                <template v-if="filter.type === 'select'">
                                                    <select v-model="filter.value" class="form-select form-select-sm">
                                                        <option v-for="option in getFilterOptions(filter.key)" :key="option.value" :value="option.value">
                                                            {{$t(option.label)}}
                                                        </option>
                                                    </select>
                                                </template>
                                                <template v-else>
                                                    <input v-model="filter.value" type="number" class="form-control form-control-sm" :placeholder="$t('min_amount')">
                                                </template>
                                                <button class="btn btn-outline-danger" type="button" @click="removeFilter(index)">
                                                    <AppIcon name="bi-trash" class="bi bi-trash" />
                                                </button>
                                            </div>
                                        </div>
                                        <hr class="dropdown-divider">
                                    </div>

                                    <!-- Add Filter Options -->
                                    <div class="d-grid gap-2">
                                        <button v-for="filter in selectableFilters" :key="filter.key" 
                                                class="btn btn-sm btn-outline-primary text-start" 
                                                @click="addFilter(filter)">
                                            <AppIcon name="bi-plus" class="bi bi-plus" /> {{$t(filter.key)}}
                                        </button>
                                    </div>

                                    <!-- Apply and Clear -->
                                    <div class="d-flex justify-content-between align-items-center mt-3">
                                        <button class="btn btn-sm btn-success" @click="applyFilters">
                                            {{$t('apply')}}
                                        </button>
                                        <button v-if="activeFilters.length > 0" class="btn btn-link btn-sm text-decoration-none text-danger p-0" @click="clearAllFilters">
                                            {{$t('clear_all')}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Spacer for desktop -->
                        <div class="col d-none d-md-block"></div>
                        
                        <!-- Date picker -->
                        <div class="col-12 col-md-3 col-lg-2">
                            <label class="form-label small d-md-none mb-1">{{$t('filter_by_date')}}</label>
                            <select v-model="dateRangeOption" @change="handleDateRangeChange" class="form-select form-select-sm">
                                <option value="">{{$t('filter_by_date')}}</option>
                                <option value="today">{{$t('today')}}</option>
                                <option value="yesterday">{{$t('yesterday')}}</option>
                                <option value="this_week">{{$t('this_week')}}</option>
                                <option value="last_week">{{$t('last_week')}}</option>
                                <option value="this_month">{{$t('this_month')}}</option>
                                <option value="custom">{{$t('custom_date')}}</option>
                            </select>
                        </div>
                        <div class="col-12 col-md-3 col-lg-2" v-if="dateRangeOption === 'custom'">
                            <label class="form-label small d-md-none mb-1">{{$t('custom_date')}}</label>
                            <date-picker :clearable="true" :editable="false" class="w-100" v-model="range" type="date" range :multi-calendars="1" :placeholder="$t('select_date_range')"></date-picker>
                        </div>
                    </div>

                <div class="page-table-container mb-6 bg-white rounded shadow">

                    <!-- table -->
                    <div class="table-responsive">
                        <table class="table mb-0 table-borderless table-striped small">
                            <thead>
                                <tr class="text-secondary">
                                    <th class="pt-4 pb-3 px-6" style="width: 40px;">
                                        <div class="form-check mb-0">
                                            <input type="checkbox" class="form-check-input" :checked="isAllSelected" @change="toggleSelectAll" :disabled="!paidTransactions.length">
                                        </div>
                                    </th>
                                    <sortable-table-header field="reference" label="reference" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getPos)" />
                                    <sortable-table-header field="total_amount" label="total_amount" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getPos)" />
                                    <sortable-table-header field="status" label="status" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getPos)" />
                                    <th class="pt-4 pb-3 px-6">{{$t('cash_register')}}</th>
                                    <th class="pt-4 pb-3 px-6">{{$t('cashier')}}</th>
                                    <sortable-table-header field="created_at" label="created_at" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getPos)" />
                                    <!-- <th class="pt-4 pb-3 px-6">{{$t('action')}}</th> -->
                                </tr>
                            </thead>
                            <tbody>
                            <tr v-for="item in pos" :key="item.id" :class="{'table-active': isSelected(item.id)}">
                            <td class="py-5 px-6">
                                <div class="form-check mb-0">
                                    <input v-if="item.payment_status === 'paid'" type="checkbox" class="form-check-input" :checked="isSelected(item.id)" @change="toggleSelect(item)">
                                </div>
                            </td>
                            <td class="py-5 px-6">
                                <router-link :to="{ path: `/pos-transactions/${item.id}` }" style="cursor: pointer;"><b>{{item.reference}}</b></router-link>
                            </td>
                                <td class="py-5 px-6">{{formatMoney(item.total_amount)}}</td>
                                <td class="py-5 px-6">
                                    <span :class="{
                                        'badge bg-success': item.payment_status === 'paid',
                                        'badge bg-danger': item.payment_status === 'canceled',
                                        'badge bg-warning': item.payment_status === 'pending'
                                    }">
                                        {{$t(item.payment_status)}}
                                    </span>
                                </td>
                                <td class="py-5 px-6">
                                    <router-link v-if="item.cash_register" :to="{ path: `/pos-cash-registers/${item.cash_register.id}` }" style="cursor: pointer;">
                                        {{ item?.cash_register?.reference }}
                                    </router-link>
                                </td>
                                <td class="py-5 px-6">{{ item.cashier?.name || item.cashier?.email || '-' }}</td>
                                <td class="py-5 px-6">{{formatDate(item.created_at)}}</td>
                                <!-- <td class="py-5 px-6"></td> -->
                            </tr>

                            </tbody>
                        </table>
                        <div v-if="count > pos.length" style="text-align:center;margin-top:1rem;margin-bottom:1rem">
                            <compact-pagination :pages="pagination" :current-page="page" @change="getPos" />
                        </div>


                    </div>
                    <!-- table -->
                    <table-loading-bar v-if="loading" class="page-table-state text-center" />
                    <div v-if="loading === false && !pos.length && !isFiltered" class="page-table-state text-center py-5 my-5 bg-white rounded shadow-sm border" style="border-style: dashed !important;">
                        <AppIcon name="bi-receipt" class="bi bi-receipt text-muted" style="font-size: 3rem;" />
                        <h4 class="mt-3">{{ $t('no_transactions_added') }}</h4>
                        <p class="text-muted">{{ $t('start_by_making_pos_sales') }}</p>
                        <router-link to="/pos" class="btn btn-outline-primary mt-2">
                            {{ $t('go_to_pos') }}
                        </router-link>
                    </div>
                    <div v-if="loading === false && !pos.length && isFiltered" class="page-table-state text-center" style="padding:1rem">{{$t('no_transactions_found')}}.</div>

                </div>

                <div class="col-sm-7">
                    {{$t('show')}}
                    <select v-model="per_page" class="form-select mb-3" name="Resulats" style="cursor:pointer;margin-right: 5px;width:100px;display:inline-block">
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="15">15</option>
                           <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    {{$t('entities')}}
                </div>

                </div>
            </section>
      </div>

      <!-- Selection Action Bar -->
      <transition name="slide-up">
        <div v-if="selectedTransactions.length > 0" class="position-fixed bottom-0 start-50 translate-middle-x mb-4 p-3 bg-white shadow rounded d-flex align-items-center gap-3" style="z-index: 1050; border: 1px solid #dee2e6; min-width: 450px; justify-content: space-between;">
            <div class="d-flex align-items-center">
                <span class="fw-bold me-2">{{ selectedTransactions.length }}</span>
                <span class="text-muted me-3">{{ $t('selected') }}</span>
                <span class="text-muted small border-start ps-3">{{ $t('total') }}: <strong class="text-dark">{{ formatMoney(selectedTotal) }}</strong></span>
            </div>
            <div class="d-flex gap-2">
                <button class="btn btn-outline-secondary btn-sm" @click="clearSelection">
                    <AppIcon name="bi-x-circle" class="bi bi-x-circle me-1" /> {{ $t('clear_all') }}
                </button>
                <button v-if="helper.checkAccess('create_invoices') > 0" class="btn btn-dark btn-sm" :disabled="transferLoading" @click="transferSelectedToInvoice">
                    <span v-if="transferLoading" class="spinner-border spinner-border-sm me-1" role="status"></span>
                    <AppIcon name="bi-arrow-left-right" v-else class="bi bi-arrow-left-right me-1" />
                    {{ $t('transfer_to_invoice') }}
                </button>
            </div>
        </div>
      </transition>

      <!-- create Modal -->
      <add-edit-invoice-modal 
          v-if="createModalisOpen" 
          @modalClosed="createModalisOpen = false"
          modalId="create-invoice-modal-01" 
          :isModalOpen="createModalisOpen" 
          :data="invoice" 
          action="create"
          @refresh="getPos"
      ></add-edit-invoice-modal>


  </div>
</template>

<script>
// @ is an alias to /src
import helper from '../../helper'
import moment from 'moment'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import AddEditInvoiceModal from '../../components/invoice/AddEditInvoiceModal';
import sortableList from '../../mixins/sortableList'

export default {
  name: 'PosTransactions',
  persistedFilterState: {
    key: 'pos-transactions',
    fields: ['search', 'filters', 'activeFilters', 'dateRangeOption', 'range', 'start', 'end', 'per_page', 'sortField', 'sortDirection'],
    dateFields: ['range'],
  },
  mixins: [sortableList],
  components :{
    DatePicker,
    AddEditInvoiceModal
  },
  data(){
    return {
        search : '',
        pos : [],
        count : 0,
        page : 1,
        pagination : [],
        range: [],
        start : null,
        end : null,
        showAdvancedSearch : false,
        filters : {
            reference : '',
            cashier : '',
            cash_register : '',
            total_amount : '',
            payment_status : '',
        },
        activeFilters: [],
        availableFilters: [
            { 
                key: 'status', 
                type: 'select',
                options: [
                    { value: 'pending', label: 'pending' },
                    { value: 'paid', label: 'paid' },
                    { value: 'canceled', label: 'canceled' }
                ] 
            },
            { 
                key: 'total_amount', 
                type: 'number'
            }
        ],
        searchTimeout : null,
        dateRangeOption: '',
        createModal : null,
        editModal : null,
        loading : false,
        transferLoading : false,
        per_page : 25,
        url : '',
        selectedTransactions : [],
        status :'all',
        createModalisOpen : false,
        invoice : {
            id : null,
            reference : '',
            date : '',
            notes : '',
            products : [], 
            client_id : null,
            client : {},
            payment_method : 'cash',
            status : 'paid',
            rest : 0,
            total : 0,
            amount_paid : 0,
        },
    }
  },
  mounted(){
    window.mixpanel.track("pos_transactions");
    
    //check permissions
    if(helper.checkAccess('view_pos_transactions') == -1) return this.$router.push({path : '/'})
    if(helper.checkAccess('view_pos_transactions') == -2) return this.$router.push({path : '/subscribe'})

    // Initialize this_month date range
    // this.handleDateRangeChange()

    this.getPos()

  },
  methods : {
    formatMoney(number) { return helper.formatMoney(number);},
    async deleteRow(row){
        const result = await this.$swal.fire({
            title: `${this.$t('are_you_sure')}?`,
            text : this.$t('you_cant_revert'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t('yes_delete_it')
        })
        if (result.isConfirmed) {
            await helper.customDelete(`${process.env.VUE_APP_API}/pos/${row.id}`)
            this.pos = helper.withoutDeletedRecords(this.pos, row.id)
            this.count = Math.max(0, this.count - 1)
        }
    },
    async getPos(page){
        try{
            this.loading = true
            this.page = page ? page : 1
            this.pos = this.page == 1 ? [] : this.pos

            // Extract filters
            const statusFilter = this.activeFilters.find(f => f.key === 'status');
            const status = statusFilter ? statusFilter.value : this.status;
            const totalAmountFilter = this.activeFilters.find(f => f.key === 'total_amount');

            // Build query params
            const params = new URLSearchParams();
            params.append('page', this.page);
            params.append('per_page', this.per_page);
            params.append('status', status);
            this.appendSortParams(params);

            if (this.start && this.end) {
                params.append('start', this.start);
                params.append('end', this.end);
            }

            if (this.search) params.append('keyword', this.search);
            if (totalAmountFilter && totalAmountFilter.value) params.append('total_amount', totalAmountFilter.value);

            // Add advanced filters
            if (this.filters.reference) params.append('reference', this.filters.reference);
            if (this.filters.cashier) params.append('cashier', this.filters.cashier);
            if (this.filters.cash_register) params.append('cash_register', this.filters.cash_register);
            if (this.filters.payment_status) params.append('payment_status', this.filters.payment_status);

            let url = `${process.env.VUE_APP_API}/pos?${params.toString()}`;

            const response = await helper.customGet(url)
            this.pos = response.data.data
            if(this.per_page != response.data.per_page){
                this.per_page = response.data.per_page
            }

            this.page = response.data.current_page
            this.count = response.data.count
            this.loading = false

            //pagination
            this.pagination = []
            let MaxPagination = Math.ceil(this.count / this.per_page )
            for(let i = 1 ; i <= MaxPagination ;i++){
                this.pagination.push(i)
            }
        }catch(error){
            this.loading = false
        }
    },
    //helper functions
    formatDate(date) { return helper.formatDate(date) },
    redirectToDetails(id) {
        this.$router.push({ path: `/pos/transactions/${id}` });
    },
    toggleAdvancedSearch(){
        this.showAdvancedSearch = !this.showAdvancedSearch
    },
    clearFilters(){
        this.filters = {
            reference : '',
            cashier : '',
            cash_register : '',
            total_amount : '',
            payment_status : '',
        }
        this.getPos()
    },
    debouncedSearch(){
        // Clear existing timeout
        if(this.searchTimeout) {
            clearTimeout(this.searchTimeout)
        }
        
        // Set new timeout
        this.searchTimeout = setTimeout(() => {
            this.getPos()
        }, 500) // 500ms delay
    },
    // Handle date range selection
    handleDateRangeChange() {
      const option = this.dateRangeOption
      if (!option || option === 'custom') {
        if (option === 'custom') return
        this.range = []
        this.start = null
        this.end = null
        this.getPos()
        return
      }

      const today = moment()
      let start, end

      switch(option) {
        case 'today':
          start = today.clone().startOf('day')
          end = today.clone().endOf('day')
          break
        case 'yesterday':
          start = today.clone().subtract(1, 'days').startOf('day')
          end = today.clone().subtract(1, 'days').endOf('day')
          break
        case 'this_week':
          start = today.clone().startOf('isoWeek')
          end = today.clone().endOf('isoWeek')
          break
        case 'last_week':
          start = today.clone().subtract(1, 'weeks').startOf('isoWeek')
          end = today.clone().subtract(1, 'weeks').endOf('isoWeek')
          break
        case 'this_month':
          start = today.clone().startOf('month')
          end = today.clone().endOf('month')
          break
        default:
          return
      }

      this.range = [start.toDate(), end.toDate()]
      this.start = start.format('YYYY-MM-DD')
      this.end = end.format('YYYY-MM-DD')
      this.getPos()
    },
    addFilter(filter) {
        if (!this.isFilterActive(filter.key)) {
            const defaultVal = filter.type === 'select' ? filter.options[0].value : '';
            this.activeFilters.push({ 
                key: filter.key, 
                value: defaultVal,
                type: filter.type || 'select'
            });
        }
    },
    removeFilter(index) {
        this.activeFilters.splice(index, 1);
    },
    isFilterActive(key) {
        return this.activeFilters.some(f => f.key === key);
    },
    getFilterOptions(key) {
        const filter = this.availableFilters.find(f => f.key === key);
        return filter ? filter.options : [];
    },
    applyFilters() {
        // Sync status from active filter to the status data property
        const statusFilter = this.activeFilters.find(f => f.key === 'status');
        if (statusFilter) {
            this.status = statusFilter.value;
        } else {
            this.status = 'all';
        }
        this.getPos();
    },
    // Multi-select methods
    isSelected(id) {
        return this.selectedTransactions.some(t => t.id === id);
    },
    toggleSelect(item) {
        const index = this.selectedTransactions.findIndex(t => t.id === item.id);
        if (index > -1) {
            this.selectedTransactions.splice(index, 1);
        } else {
            this.selectedTransactions.push(item);
        }
    },
    toggleSelectAll() {
        if (this.isAllSelected) {
            // Deselect all paid from current page
            this.selectedTransactions = this.selectedTransactions.filter(
                s => !this.paidTransactions.some(p => p.id === s.id)
            );
        } else {
            // Add all paid transactions from current page
            this.paidTransactions.forEach(t => {
                if (!this.isSelected(t.id)) {
                    this.selectedTransactions.push(t);
                }
            });
        }
    },
    clearSelection() {
        this.selectedTransactions = [];
    },
    async transferSelectedToInvoice() {
        if (!this.selectedTransactions.length) return;

        const result = await this.$swal.fire({
            title: this.$t('transfer_to_invoice'),
            html: `<p>${this.$t('merge_transactions_confirm', { count: this.selectedTransactions.length })}</p>
                   <p><strong>${this.$t('total')}: ${this.formatMoney(this.selectedTotal)}</strong></p>`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#004aad',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t('confirm'),
            cancelButtonText: this.$t('cancel')
        });

        if (!result.isConfirmed) return;

        try {
            this.transferLoading = true;

            // Fetch full details for each selected transaction
            const transactionDetails = await Promise.all(
                this.selectedTransactions.map(t =>
                    helper.customGet(`${process.env.VUE_APP_API}/pos/${t.id}`).then(r => r.data)
                )
            );

            // Merge products from all transactions
            const allProducts = [];
            let totalAmount = 0;
            let subTotal = 0;
            let totalVat = 0;
            let totalDiscount = 0;
            const references = [];
            const posTransactionIds = [];
            // Use the first transaction's client if available
            let clientId = null;
            let client = null;

            for (const tx of transactionDetails) {
                posTransactionIds.push(tx.id);
                references.push(tx.reference);
                totalAmount += parseFloat(tx.total_amount) || 0;
                subTotal += parseFloat(tx.sub_total) || 0;
                totalVat += parseFloat(tx.total_vat) || 0;
                totalDiscount += parseFloat(tx.total_discount) || 0;

                if (!clientId && tx.client_id) {
                    clientId = tx.client_id;
                    client = tx.client;
                }

                if (tx.products && tx.products.length) {
                    const discountPercent = parseFloat(tx.discount) || 0;
                    const vatPercent = parseFloat(this.business.vat) || 0;

                    tx.products.forEach(product => {
                        const quantity = parseFloat(product.quantity) || 0;
                        const unitPrice = parseFloat(product.unit_price) || 0;
                        const purchasePrice = parseFloat(product.purchase_price) || 0;
                        const prodSubTotal = quantity * unitPrice;
                        const discountAmount = prodSubTotal * (discountPercent / 100);
                        const afterDiscount = prodSubTotal - discountAmount;
                        const vatAmount = afterDiscount * (vatPercent / 100);
                        const total = afterDiscount + vatAmount;

                        allProducts.push({
                            product_id: product.product_id,
                            inventory_id: product.inventory_id,
                            product_label: product.product?.label || product.name,
                            quantity: quantity,
                            price: unitPrice,
                            purchase_price: purchasePrice,
                            discount: discountPercent,
                            vat: vatPercent,
                            total: parseFloat(total.toFixed(2)),
                            sub_total: parseFloat(prodSubTotal.toFixed(2)),
                            custom_product: false
                        });
                    });
                }
            }

            // Add an empty row for new products in the modal
            allProducts.push({
                product_label: '',
                product_id: null,
                quantity: 0,
                price: 0,
                discount: 0,
                vat: parseFloat(this.business.vat) || 0,
                total: 0,
                sub_total: 0,
                custom_product: false
            });

            const invoiceData = {
                client_id: clientId,
                client: client,
                date: new Date().toISOString().split('T')[0],
                status: 'paid',
                payment_method: 'cash',
                amount_paid: totalAmount,
                total: parseFloat(totalAmount.toFixed(2)),
                sub_total: parseFloat(subTotal.toFixed(2)),
                total_vat: parseFloat(totalVat.toFixed(2)),
                total_discount: parseFloat(totalDiscount.toFixed(2)),
                notes: `Transferred from POS transactions: ${references.join(', ')}`,
                pos_transaction_ids: posTransactionIds,
                products: allProducts
            };

            this.invoice = invoiceData;
            this.createModalisOpen = true;
            this.selectedTransactions = [];
        } catch (error) {
            this.$swal.fire({
                title: this.$t('error') || 'Error',
                text: error?.response?.data?.message || this.$t('failed_to_prepare_invoice') || 'Failed to create invoice',
                icon: 'error',
                confirmButtonText: this.$t('ok') || 'OK'
            });
        } finally {
            this.transferLoading = false;
        }
    },
    clearAllFilters() {
        this.activeFilters = [];
        this.status = 'all';
        this.selectedTransactions = [];
        this.getPos();
    }
  },
  watch : {
    async search(){
        if(this.search.length > 2 || this.search.length === 0){
            this.debouncedSearch()
        }
    },
    // Watch individual filter fields for real-time search
    'filters.reference'(){
        if(this.filters.reference.length > 2 || this.filters.reference.length === 0){
            this.debouncedSearch()
        }
    },
    'filters.cashier'(){
        if(this.filters.cashier.length > 2 || this.filters.cashier.length === 0){
            this.debouncedSearch()
        }
    },
    'filters.cash_register'(){
        if(this.filters.cash_register.length > 2 || this.filters.cash_register.length === 0){
            this.debouncedSearch()
        }
    },
    'filters.total_amount'(){
        if(this.filters.total_amount.length > 0 || this.filters.total_amount.length === 0){
            this.debouncedSearch()
        }
    },
    'filters.payment_status'(){
        this.debouncedSearch()
    },
    range(val) {
        if (val && val.length === 2 && val[0] && val[1]) {
            this.start = moment(val[0]).format('YYYY-MM-DD')
            this.end = moment(val[1]).format('YYYY-MM-DD')
            this.getPos(1)
        } else {
            this.start = null
            this.end = null
            this.getPos(1)
        }
    },
    per_page(){
        this.getPos(this.page)
    },
    status(){
        this.getPos()
    }
  },
  computed: {
    selectableFilters() {
        return this.availableFilters.filter(f => !this.isFilterActive(f.key));
    },
    isFiltered() {
      return (this.activeFilters.length > 0) || 
             (this.search && this.search.length > 0) ||
             (this.dateRangeOption && this.dateRangeOption !== '') ||
             (this.filters.reference && this.filters.reference !== '') ||
             (this.filters.cashier && this.filters.cashier !== '') ||
             (this.filters.cash_register && this.filters.cash_register !== '') ||
             (this.filters.total_amount && this.filters.total_amount !== '') ||
             (this.filters.payment_status && this.filters.payment_status !== '') ||
             (this.status && this.status !== 'all' && this.status !== '');
    },
    paidTransactions() {
      return this.pos.filter(t => t.payment_status === 'paid');
    },
    isAllSelected() {
      return this.paidTransactions.length > 0 && this.paidTransactions.every(t => this.selectedTransactions.some(s => s.id === t.id));
    },
    selectedTotal() {
      return this.selectedTransactions.reduce((sum, t) => sum + parseFloat(t.total_amount || 0), 0);
    },
    business(){ return this.$store.getters.BUSINESS },
    helper(){ return helper }
  }
}
</script>

<style scoped>
    .table-borderless>:not(caption)>*>*{
        padding: 5px !important
    }
    
    .advanced-search-section {
        background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
        border: 1px solid #dee2e6;
        border-radius: 8px;
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    }
    
    .filter-input {
        transition: all 0.3s ease;
    }
    
    .filter-input:focus {
        border-color: #303030;
        box-shadow: 0 0 0 0.2rem rgba(83, 77, 255, 0.25);
    }
    
    .btn-outline-primary {
        border-color: #cbd5e1;
        color: #334155;
    }
    
    .btn-outline-primary:hover {
        background-color: #004aad;
        border-color: #004aad;
        color: white;
    }
    
    .btn-outline-primary.active {
        background-color: #004aad;
        border-color: #004aad;
        color: white;
    }

    /* Selection Action Bar */
    .slide-up-enter-active,
    .slide-up-leave-active {
        transition: all 0.3s ease;
    }

    .slide-up-enter-from,
    .slide-up-leave-to {
        transform: translate(-50%, 100%);
        opacity: 0;
    }

    .table-active {
        background-color: rgba(48, 48, 48, 0.06) !important;
    }

    .form-check-input {
        cursor: pointer;
    }

    .form-check-input:checked {
        background-color: #303030;
        border-color: #303030;
    }
</style>
